import { render, staticRenderFns } from "./ShopNowButton.vue?vue&type=template&id=a67855d4&scoped=true"
import script from "./ShopNowButton.vue?vue&type=script&lang=js"
export * from "./ShopNowButton.vue?vue&type=script&lang=js"
import style0 from "./ShopNowButton.vue?vue&type=style&index=0&id=a67855d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67855d4",
  null
  
)

export default component.exports